import { useId, useState, type ReactNode } from 'react';
import { Icone } from './Icone';

/**
 * Note sous un bloc (charte, doc 06, § 6.9). Une phrase reste visible : ce
 * qu'il faut savoir avant d'agir. Le reste — le pourquoi, les cas limites —
 * se déplie au bouton d'information, sans quitter l'écran ni passer par une
 * infobulle, illisible au-delà d'une ligne et inaccessible au clavier.
 *
 * Sans `children`, la note n'a rien à déplier et le bouton n'apparaît pas.
 */
export function Note({
  resume,
  children,
  tete = false,
}: {
  resume: ReactNode;
  children?: ReactNode;
  /** Note de tête : lue avant d'agir, placée en haut du bloc. */
  tete?: boolean;
}) {
  const [ouverte, setOuverte] = useState(false);
  const id = useId();
  return (
    <div className={tete ? 'note note--tete' : 'note'}>
      <p>
        {resume}
        {children && (
          <button
            type="button"
            className="note__info"
            aria-expanded={ouverte}
            aria-controls={id}
            aria-label={ouverte ? 'Masquer le détail' : 'Afficher le détail'}
            title={ouverte ? 'Masquer le détail' : 'Afficher le détail'}
            onClick={() => setOuverte((o) => !o)}
          >
            <Icone nom="information" taille={14} />
          </button>
        )}
      </p>
      {children && (
        <p id={id} className="note__detail" hidden={!ouverte}>
          {children}
        </p>
      )}
    </div>
  );
}
